import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** PRCZ（P計画・Rのんびり・C安心安定・Z癒し） */
const prczContent: DiagnosisResultContent = {
  code: 'PRCZ',
  name: 'ほどほど快適派',
  catchphrase: '無難が一番、でもちゃんと楽しい。ストレスフリーな旅の賢者',
  rarity: 3,
  style:
    '「がんばりすぎず、でも快適に」を大切にする計画派。定番で安心できる宿やスポットを選び、ゆったりした日程で心地よさを優先する。冒険や詰め込みは求めず、移動も体験も「ほどほど」がちょうどいい。背伸びしないからこそ疲れず、毎回満足度が安定する。穏やかで持続可能な旅を知る、快適主義タイプ。',
  strengths: [
    { lead: '疲れにくい旅設計', text: 'ゆとりある日程で、心身ともに無理なく過ごせる。' },
    { lead: '満足度が安定', text: '定番と快適さを優先するため、ハズレが少ない。' },
    { lead: '穏やかで揉めにくい', text: '欲張らない姿勢が、同行者との衝突を和らげる。' },
  ],
  weaknesses: [
    { lead: '刺激は少なめ', text: '安全・快適優先で、記憶に残る非日常体験は控えめ。' },
    { lead: '変化が苦手', text: '慣れたパターンを好み、新しい挑戦に腰が重い。' },
    { lead: '受け身になりやすい', text: '「ほどほど」を求めるあまり、主体的な提案が減りがち。' },
  ],
  aaru: [
    { icon: 'coffee', text: '宿でのんびりが最高の贅沢' },
    { icon: 'msg', text: '「無理しなくていいよ」が口癖' },
    { icon: 'camera', text: '定番スポットを快適ペースで' },
    { icon: 'coffee', text: '予定は詰めすぎないのが信条' },
  ],
  manual: {
    good: 'ゆったり日程を尊重する／快適さを一緒に大事にする',
    ng: '「せっかくだから」と予定を盛る',
    tips: '移動は短く、滞在は長く設計すると満足度が上がる',
  },
  compatibility: {
    good: 'PRCE（バランス）／PACZ（安心計画）',
    conflict: 'SALE（爆速即興）／PALE（詰め込み食）',
    tips: '休憩時間を旅程に明記しておくと安心して動ける',
  },
  destinations: {
    domestic: '箱根（温泉でゆったり）／沖縄離島（のんびり滞在）',
    overseas: 'グアム（近くて快適）／ハワイ（安心の癒しリゾート）',
  },
};

export const prczDiagnosisResult = buildDiagnosisResult(prczContent);
